/*eslint-disable */
import toast from '@/services/toast';
const $ = window.jQuery = require('jquery'); 
import {
  bus
} from '@/main';
export default {
  name: 'trash-paper-restore',
  components: {},
  props: ['trashPaperID', 'trashItemNAME'],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    getPaperPileListAgain(){
      this.$store.dispatch('getTrashPaperListFun')
      this.$store.dispatch('getTrashFolderListFun')
      this.$store.dispatch('getBucketListOfAwerackFun')
    },
    closeRemoveItemModalFun(){
      bus.$emit('trashPaperRestoreStateBus', false)
      $('body').removeClass('body_right_scroll_remove')
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('trashPaperRestoreFun', {id:this.trashPaperID}).then
      ((res) => {
        toast.success(res.data.msg);
        this.getPaperPileListAgain()
        this.closeRemoveItemModalFun()
      }).catch((err) => {
        toast.error(err.data.user_msg || err.data.msg);
      })
    }
  }
}